import React, {Component} from 'react';
import MyFrame from '../components/Frame';
import {Switch, Route, Redirect} from 'react-router-dom';
import {api, app} from "../app";
import '../css/bigdata.css';
import BData from "./bigData/BData";
import SignView from "./bigData/SignView";
import SignDate from "./bigData/SignDate";
import SignTeam from "./bigData/SignTeam";
import SignWhiteList from "./bigData/SignWhiteList";
import WorkReport from "./bigData/WorkReport"

function checkMenu(path) {
    let key = '1';
    switch (path) {
        case '/bigdata/sign-view':
            key = '2';
            break;
        case '/bigdata/sign-date':
            key = '3';
            break;
        case '/bigdata/sign-team':
            key = '4';
            break;
        case '/bigdata/sign-whiterlist':
            key = '5';
            break;
        case '/bigdata/work-report':
            key = '6';
            break;
    }
    return key;
}

class BigData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu_key: checkMenu(props.location.pathname),
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data)

    componentWillReceiveProps (nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
        }
    }

    render() {
        let {menu_key} = this.state, rights = app.getData('rights'),
            menuList = [
                {key: '1', text: '存心大数据', link: '/bigdata'},
                {key: '6', text: '工作简报', link: '/bigdata/work-report'},
            ],
            nodes = [];
        if ('13'.indexOf(rights) !== -1) {
            menuList.push(
                {key: '2', text: '签到总览', link: '/bigdata/sign-view'},
                {key: '3', text: '个人签到时间', link: '/bigdata/sign-date'},
                {key: '4', text: '队伍签到时间率', link: '/bigdata/sign-team'}
            );
            nodes.push(
                (<Route key="1" exact path="/bigdata/sign-view" component={SignView}/>),
                (<Route key="2" exact path="/bigdata/sign-date" component={SignDate}/>),
                (<Route key="3" exact path="/bigdata/sign-team" component={SignTeam}/>),
            );
        }
        if (rights === 1) {
            menuList.push(
                {key: '5', text: '查看签到白名单', link: '/bigdata/sign-whiterlist'},
            );
            nodes.push(
                (<Route key="4" exact path="/bigdata/sign-whiterlist" component={SignWhiteList}/>),
            );
        }
        return (
            <MyFrame className="bigdata" history={this.props.history} menuList={menuList} menuSelectKey={menu_key} siderWidth="10rem">
                <Switch>
                    
                    <Route exact path="/bigdata" component={BData}/>
                    <Route exact path="/bigdata/work-report" component={WorkReport}/>
                    {nodes}
                    <Route render={() => <Redirect to="/bigdata"/>}/>
                </Switch>
            </MyFrame>
        );
    }
}

export default BigData;



// WEBPACK FOOTER //
// ./src/routes/BigData.jsx